import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    ctaSubmit: 'Next',
    description: {
      mandatee:
        'This information should be identical to that indicated in the draft statutes.',
      nonMandatee:
        'This information should be identical to that indicated in your draft statutes.',
    },
    helpDescription: {
      mandatee:
        'The legal forms shown above are the most common forms, but we accept other types of companies. If the legal form of the company is not listed, you can contact us directly.',
      nonMandatee:
        'The legal forms shown above are the most common forms, but we accept other types of companies. If your legal form is not listed, you can contact us directly.',
    },
    helpLink: 'Contact us',
    helpTitle: {
      mandatee: 'The legal form for the company is not on the list',
      nonMandatee: 'The legal form for my company is not on the list',
    },
    inseeLegalFormCode: {
      label: {
        mandatee: 'Legal form of the company',
        nonMandatee: 'Legal form of your company',
      },
      placeholder: 'Select a status',
    },
    legalName: {
      label: {
        mandatee: 'Name of the company',
        nonMandatee: 'Name of your company',
      },
      placeholder: {
        mandatee: 'The legal name of the company',
        nonMandatee: 'The legal name of your company',
      },
    },
    title: { mandatee: 'The company', nonMandatee: 'Your company' },
  },
  fr: {
    ctaSubmit: 'Suivant',
    description: {
      mandatee:
        'Ces informations doivent correspondre exactement à celles qui figurent dans le projet de statuts de la société.',
      nonMandatee:
        'Ces informations doivent correspondre exactement à celles qui figurent dans le projet de statuts de votre société.',
    },
    helpDescription: {
      mandatee:
        'Les formes juridiques ci-dessus sont les plus courantes, mais nous acceptons d’autres types de sociétés. Si la forme juridique de l’entreprise n’est pas dans la liste, vous pouvez nous contacter directement.',
      nonMandatee:
        'Les formes juridiques ci-dessus sont les plus courantes, mais nous acceptons d’autres types de sociétés. Si votre forme juridique n’est pas dans la liste, vous pouvez nous contacter directement.',
    },
    helpLink: 'Nous contacter',
    helpTitle: {
      mandatee: 'La forme juridique de l’entreprise est absente de la liste',
      nonMandatee:
        'La forme juridique de mon entreprise est absente de la liste',
    },
    inseeLegalFormCode: {
      label: {
        mandatee: 'Forme légale de l’entreprise',
        nonMandatee: 'Forme légale de votre entreprise',
      },
      placeholder: 'Choisissez le statut',
    },
    legalName: {
      label: {
        mandatee: 'Nom de la société',
        nonMandatee: 'Nom de votre société',
      },
      placeholder: {
        mandatee: 'Le nom légal de la société',
        nonMandatee: 'Le nom légal de votre société',
      },
    },
    title: { mandatee: 'La société', nonMandatee: 'Votre société' },
  },
} as const);
